import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { AppLoader } from '~/components/AppLoader';
import DocumentTitle from '~/components/DocumentTitle';
import { HeaderLogo } from '~/components/HeaderLogo';
import { withSessionRedirect } from '~/components/withSessionRedirect';
import { FEATURE_FLAGS } from '~/constants/featureFlags';
import { PLATFORMS } from '~/constants/platforms';
import { useFeature } from '~/hooks/useFeature';
import { LoginScreen } from '~/screens/LoginScreen';

function Login() {
  const router = useRouter();
  const { isEnabled, status } = useFeature(FEATURE_FLAGS.ssoRevamp);
  const [isLoading, setIsLoading] = useState<Boolean>(true);

  useEffect(() => {
    // Wait for feature flag status to resolve before proceeding
    if (status === 'loading') return;

    // If feature flag is enabled, redirect immediately
    if (isEnabled) {
      router.push(`${process.env.NEXT_PUBLIC_SSO_APP}/welcome`);
      // Keep loading state true since we're redirecting
      return;
    }
    // Feature flag is disabled, show login screen
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only want to run this effect when the token and feature flag status change
  }, [isEnabled, status]);

  if (isLoading) {
    return <AppLoader />;
  }

  return (
    <>
      <DocumentTitle>Login</DocumentTitle>
      <LoginScreen
        heading={<HeaderLogo platform={PLATFORMS.echo} heading="Log in" />}
        platform={PLATFORMS.echo}
      />
    </>
  );
}

export default withSessionRedirect(Login);
